// src/components/ui/Button.jsx
import React from "react";

const base =
  "inline-flex items-center justify-center font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-offset-1";

const variants = {
  primary:
    "bg-primary-500 text-secondary-950 hover:bg-primary-600 focus:ring-primary-400",
  secondary:
    "bg-secondary-700 text-white hover:bg-secondary-600 focus:ring-secondary-500",
  danger:
    "bg-red-600 text-white hover:bg-red-500 focus:ring-red-400",
  ghost:
    "bg-transparent text-gray-300 hover:bg-secondary-800 focus:ring-secondary-500",
};

export default function Button({ children, variant = "primary", className = "", ...props }) {
  return (
    <button className={`${base} px-4 py-2 ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}
